import { SetStateAction, useMemo } from 'react';
import { MultiSelect } from '../Inputs/MultiSelect/MultiSelect';
import { useTranslation } from 'react-i18next';
import {
  getLabelBaseOnSubscriptionStatus,
  SUBSCRIPTION_STATUS,
  SubscriptionStatus,
} from './constants/subscriptionStatus';

import { useAtom, WritableAtom } from 'jotai';

type SubscriptionStatusSelectProps = {
  subscriptionStatusesFilterAtom: WritableAtom<
    SubscriptionStatus[],
    [SetStateAction<SubscriptionStatus[]>],
    void
  >;
};

export const SubscriptionStatusSelect = ({
  subscriptionStatusesFilterAtom,
}: SubscriptionStatusSelectProps) => {
  const [subscriptionStatuses, setSubscriptionStatuses] = useAtom(subscriptionStatusesFilterAtom);
  const { t } = useTranslation();

  const subscriptionStatusOptions = useMemo(
    () => [
      {
        label: getLabelBaseOnSubscriptionStatus(SUBSCRIPTION_STATUS.ACTIVE, t),
        value: SUBSCRIPTION_STATUS.ACTIVE,
      },
      {
        label: getLabelBaseOnSubscriptionStatus(SUBSCRIPTION_STATUS.DEACTIVATED, t),
        value: SUBSCRIPTION_STATUS.DEACTIVATED,
      },
      {
        label: getLabelBaseOnSubscriptionStatus(SUBSCRIPTION_STATUS.TEST, t),
        value: SUBSCRIPTION_STATUS.TEST,
      },
      {
        label: getLabelBaseOnSubscriptionStatus(SUBSCRIPTION_STATUS.TERMINATED, t),
        value: SUBSCRIPTION_STATUS.TERMINATED,
      },
    ],
    [t],
  );
  return (
    <MultiSelect<SubscriptionStatus>
      sx={{ width: '100%', height: 'auto' }}
      data-testid={'subscription-status-multiselect'}
      name="subscriptionStatus"
      value={subscriptionStatuses}
      onChange={(value) => {
        setSubscriptionStatuses(value);
      }}
      placeholder={t('simInventory.subscriptionStatusPlaceholder')}
      showSelectAll={true}
      options={subscriptionStatusOptions}
    />
  );
};
